/**
 * Matrix Rain / Digital Stream Canvas Background
 * Renders subtle falling 0s, 1s and hex digits matching the Figma hacker aesthetic.
 */

export class MatrixCanvas {
  constructor(canvasId = 'matrix-canvas') {
    this.canvas = document.getElementById(canvasId);
    if (!this.canvas) return;
    this.ctx = this.canvas.getContext('2d');
    this.characters = '0101010101010101ABCDEF01';
    this.fontSize = 14;
    this.columns = 0;
    this.drops = [];
    this.animationFrameId = null;
    this.isRunning = true;

    this.init();
  }

  init() {
    this.resize();
    window.addEventListener('resize', () => this.resize());
    this.render();
  }

  resize() {
    if (!this.canvas) return;
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;
    this.columns = Math.floor(this.canvas.width / this.fontSize);
    this.drops = [];
    for (let i = 0; i < this.columns; i++) {
      this.drops[i] = Math.floor(Math.random() * -50);
    }
  }

  render() {
    if (!this.isRunning) return;

    // Subtle fade background for trail effect
    this.ctx.fillStyle = 'rgba(5, 8, 5, 0.08)';
    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

    this.ctx.fillStyle = '#00ff41';
    this.ctx.font = `${this.fontSize}px "JetBrains Mono", monospace`;

    for (let i = 0; i < this.drops.length; i++) {
      const text = this.characters.charAt(Math.floor(Math.random() * this.characters.length));
      const x = i * this.fontSize;
      const y = this.drops[i] * this.fontSize;

      // Leading character brighter
      if (Math.random() > 0.85) {
        this.ctx.fillStyle = '#a6ffb8';
      } else {
        this.ctx.fillStyle = '#00ff41';
      }

      this.ctx.fillText(text, x, y);

      if (y > this.canvas.height && Math.random() > 0.985) {
        this.drops[i] = 0;
      }
      this.drops[i]++;
    }

    this.animationFrameId = requestAnimationFrame(() => this.render());
  }

  toggle() {
    this.isRunning = !this.isRunning;
    if (this.isRunning) {
      this.render();
    } else {
      cancelAnimationFrame(this.animationFrameId);
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    return this.isRunning;
  }
}
